/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const formSubmitStyle = {
  applicationActions: (theme: Theme) => ({
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse",
      "& > div": {
        width: "100%",
      },
    },
  }),
  submitButtonContainer: {
    paddingTop: "1rem",
  },
  backButtonContainer: (theme: Theme) => ({
    paddingTop: "1rem",
    [theme.breakpoints.up("sm")]: {
      paddingRight: "5px",
    },
  }),
  backButton: {
    color: "primary.main",
  },
  buttonSubtext: {
    textAlign: "center",
    paddingTop: "2px",
  },
  invalidContainer: (theme: Theme) => ({
    marginTop: "1rem",
    [theme.breakpoints.down("sm")]: {
      order: 1,
    },
  }),
  invalidText: {
    textAlign: "center",
    color: "#f44336",
    fontSize: "0.75rem",
    fontWeight: 400,
  },
};

export default formSubmitStyle;
